{
    "warning": "คำเตือน!",
    "message": "อย่าใส่หรือวางรหัสที่คุณไม่เข้าใจลงไป\nการใช้คอนโซลนี้อาจทำให้ผู้โจมตีสามารถแอบอ้างว่าเป็นคุณ และขโมยข้อมูลของคุณโดยใช้การโจมตีที่เรียกว่า Self-XSS"
}
